/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'faction/myrmezir-small': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M23.5 8.5v15h-15v-15h15M24 8H8v16h16V8z"/><path pid="1" d="M16 5.708L26.293 16 16 26.292 5.707 16 16 5.708m0-.707L5 16l11 10.999L27 16 16 5.001zM24 5h3v3h-3zM24 24h3v3h-3zM5 24h3v3H5zM5 5h3v3H5zM.586 16L2 14.584 3.414 16 2 17.414zM28.585 16L30 14.586 31.414 16 30 17.414zM14.586 2L16 .586 17.414 2 16 3.414zM14.585 30.001l1.413-1.414 1.415 1.414L16 31.415z"/><path pid="2" d="M8 15.5h16v1H8z"/><path pid="3" d="M15.5 8h1v16h-1z"/>'
  }
})
